import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
} from '@mui/material';
import { ethers } from 'ethers';
import { connect } from 'react-redux';
import { GTTokenAbi, LPTokenAbi, SyncModuleAbi } from '../abis';
import TabWrapper from './TabWrapper';
import { getUserCredits, getCreditHistoryByNote } from '../../../../../redux/actions/credit.action';
import { getAllUserHasKatAddress, getEmailsByWalletAddressesInLPSale } from '../../../../../redux/actions/dao.action';
import { formatEther } from 'ethers/lib/utils';

let GTtoken;
let LPtoken;
let SyncModule;

const inputStyles = {
  '& .MuiInputBase-input': {
    color: '#e7e3e3',
    backgroundColor: '#282f38 !important',
    borderRadius: '4px',
  },
  '& .MuiInputLabel-root': {
    color: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#282f38 !important',
    '& fieldset': {
      borderColor: '#00EDC3',
    },
    '&:hover fieldset': {
      borderColor: '#00EDC3',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#00EDC3',
    },
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#e7e3e3',
    opacity: 0.7,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#00EDC3 !important',
  },
  '& input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 1000px #282f38 inset',
    WebkitTextFillColor: '#e7e3e3',
    caretColor: '#e7e3e3',
  },
  '& input:-moz-autofill': {
    boxShadow: '0 0 0 1000px #282f38 inset',
    color: '#e7e3e3',
    caretColor: '#e7e3e3',
  },
};

const buttonStyles = {
  backgroundColor: '#00EDC3',
  color: '#282f38',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#00EDC3',
    opacity: 0.9,
  },
};

const SyncGTLPTab = ({
  daoOrganizerAddress,
  currentDao,
  getUserCredits,
  getCreditHistoryByNote,
  getAllUserHasKatAddress,
  getEmailsByWalletAddressesInLPSale,
}) => {
  const [chainId, setChainId] = useState(null);
  const [walletAddress, setWalletAddress] = useState('');
  const [GTtokenHolderAddress, setGTtokenHolderAddress] = useState([]);
  const [LPtokenHolderAddress, setLPtokenHolderAddress] = useState([]);
  const [holderAddresses, setHolderAddresses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isCalculated, setIsCalculated] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Test getUserCredits
    const testGetUserCredits = async () => {
      try {
        const result = await getUserCredits('anh.phan@kambria.io');
      } catch (error) {
        // Removed console.error
      }
    };
    testGetUserCredits();
  }, [getUserCredits]);

  useEffect(() => {
    // Test getCreditHistoryByNote
    const testGetCreditHistoryByNote = async () => {
      try {
        // Test with a sample note
        const result = await getCreditHistoryByNote('test-note');
      } catch (error) {
        // Removed console.error
      }
    };
    testGetCreditHistoryByNote();
  }, [getCreditHistoryByNote]);

  useEffect(() => {
    // Test getAllUserHasKatAddress
    const testGetAllUserHasKatAddress = async () => {
      try {
        const result = await getAllUserHasKatAddress();
      } catch (error) {
        // Removed console.error
      }
    };
    testGetAllUserHasKatAddress();
  }, [getAllUserHasKatAddress]);

  useEffect(() => {
    // Test getEmailsByWalletAddressesInLPSale
    const testGetEmailsByWalletAddressesInLPSale = async () => {
      try {
        // Test with a valid wallet address array
        const walletAddresses = ['0xD1372BEF65AfeA1352eFE84D1c33f1878287f5d6'];
        if (!Array.isArray(walletAddresses) || walletAddresses.length === 0) {
          return;
        }
        const result = await getEmailsByWalletAddressesInLPSale(walletAddresses);
      } catch (error) {
        // Removed console.error
      }
    };
    testGetEmailsByWalletAddressesInLPSale();
  }, [getEmailsByWalletAddressesInLPSale]);

  useEffect(() => {
    if (currentDao) {
      setChainId(currentDao.chainId.toString().toLowerCase());
    }
  }, [currentDao]);

  const checkNetwork = async () => {
    if (!window.ethereum) {
      alert('Please install MetaMask!');
      return false;
    }

    const currentChainId = await window.ethereum.request({ method: 'eth_chainId' });
    // Convert hex chainId from MetaMask to decimal for comparison
    const currentChainDecimal = parseInt(currentChainId, 16).toString();

    if (currentChainDecimal !== chainId) {
      alert('Please switch to the correct network in MetaMask!');
      return false;
    }

    return true;
  };

  const connectMetamask = async () => {
    if (!(await checkNetwork())) return;

    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      setWalletAddress(accounts[0]);
      await connectTokens();
    } catch (error) {
      // Removed console.error
    }
  };

  const connectTokens = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      GTtoken = new ethers.Contract(currentDao.gtTokenAddress, GTTokenAbi, signer);
      LPtoken = new ethers.Contract(currentDao.lpTokenAddress, LPTokenAbi, signer);
      SyncModule = new ethers.Contract(currentDao.syncContract, SyncModuleAbi, signer);
    } catch (error) {
      // Removed console.error
      throw error;
    }
  };

  const handleFileUpload = async (event, type) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!(await checkNetwork())) return;

    try {
      const fileUrl = URL.createObjectURL(file);
      const response = await fetch(fileUrl);
      const text = await response.text();
      const lines = text.split('\n');
      const _data = lines.map((line) => line.split(','));

      let addresses = [];
      _data.forEach((item, index) => {
        if (index && item.length && item[0]) {
          let temp = JSON.parse(JSON.stringify(item[0]));
          temp = temp.replace(/"/g, '');
          temp = temp.trim();
          if (temp) {
            addresses.push(temp);
          }
        }
      });

      if (type === 'GT') {
        setGTtokenHolderAddress(addresses);
      } else {
        setLPtokenHolderAddress(addresses);
      }
    } catch (error) {
      // Removed console.error
    }
  };

  const getLPBalance = async (holder) => {
    try {
      return await LPtoken.balanceOf(holder);
    } catch (error) {
      // Removed console.error
      return ethers.BigNumber.from(0);
    }
  };

  const getGTBalance = async (holder) => {
    try {
      return await GTtoken.balanceOf(holder);
    } catch (error) {
      // Removed console.error
      return ethers.BigNumber.from(0);
    }
  };

  const getLPTotalSupply = async () => {
    try {
      return await LPtoken.totalSupply();
    } catch (error) {
      // Removed console.error
      return ethers.BigNumber.from(0);
    }
  };

  const getHolderInfo = async () => {
    if (GTtokenHolderAddress.length === 0 && LPtokenHolderAddress.length === 0) {
      alert('Please upload holder addresses');
      return;
    }

    setIsLoading(true);
    try {
      const lPTotalSupply = await getLPTotalSupply();
      const newHolderAddresses = [];

      for (let i = 0; i < GTtokenHolderAddress.length; i++) {
        const holder = GTtokenHolderAddress[i];
        const [lpBalance, gtBalance] = await Promise.all([getLPBalance(holder), getGTBalance(holder)]);
        const walletEmails = await getEmailsByWalletAddressesInLPSale([holder]);

        const lpBalanceNumber = Number(lpBalance);
        const lpTotalSupplyNumber = Number(lPTotalSupply);
        const percentage = (lpBalanceNumber / lpTotalSupplyNumber) * 100;

        let expectedGTbyLP = 0;
        if (percentage > 4) {
          expectedGTbyLP = (percentage * 400) / 100;
        }

        newHolderAddresses.push({
          id: newHolderAddresses.length + 1,
          holder: holder,
          LPBalance: Number(ethers.utils.formatEther(lpBalance)),
          percentage: percentage,
          GTBalance: Number(ethers.utils.formatEther(gtBalance)),
          expectedGTbyLP: expectedGTbyLP,
          email: (walletEmails?.status === 'OK' && walletEmails?.results?.[0]?.email) || '',
          expectedGTbyCredit: 0,
          totalCredit: 0,
        });
      }

      for (let i = 0; i < LPtokenHolderAddress.length; i++) {
        const holder = LPtokenHolderAddress[i];
        if (newHolderAddresses.some((h) => h.holder.toLowerCase() === holder.toLowerCase())) {
          continue;
        }

        const [lpBalance, gtBalance] = await Promise.all([getLPBalance(holder), getGTBalance(holder)]);
        const walletEmails = await getEmailsByWalletAddressesInLPSale([holder]);

        const lpBalanceNumber = Number(lpBalance);
        const lpTotalSupplyNumber = Number(lPTotalSupply);
        const percentage = (lpBalanceNumber / lpTotalSupplyNumber) * 100;

        let expectedGTbyLP = 0;
        if (percentage > 4) {
          expectedGTbyLP = (percentage * 400) / 100;
        }

        newHolderAddresses.push({
          id: newHolderAddresses.length + 1,
          holder: holder,
          LPBalance: Number(ethers.utils.formatEther(lpBalance)),
          percentage: percentage,
          GTBalance: Number(ethers.utils.formatEther(gtBalance)),
          expectedGTbyLP: expectedGTbyLP,
          email: (walletEmails?.status === 'OK' && walletEmails?.results?.[0]?.email) || '',
          expectedGTbyCredit: 0,
          totalCredit: 0,
        });
      }

      const creditHistory = await getCreditHistoryByNote(currentDao?.code);

      if (creditHistory && creditHistory.data && Array.isArray(creditHistory.data)) {
        for (let holder of newHolderAddresses) {
          const userCredit = creditHistory.data.find(
            (credit) => credit.katAddress?.toLowerCase() === holder.holder.toLowerCase(),
          );
          if (userCredit && userCredit.totalAmount >= 3) {
            holder.expectedGTbyCredit = 4;
            holder.totalCredit = userCredit.totalAmount;
          }
        }
      }

      setHolderAddresses(newHolderAddresses);
      setIsCalculated(true);
    } catch (error) {
      setError('Error processing holder information');
    } finally {
      setIsLoading(false);
    }
  };

  const calculateSync = async () => {
    try {
      if (window.ethereum !== 'undefined') {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        setWalletAddress(accounts[0]);

        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const network = await provider.getNetwork();
        const netWorkId = network.chainId;

        if (netWorkId.toString() !== chainId.toString()) {
          alert('Wrong network. Please change your wallet network to Chain ID ' + netWorkId);
          return;
        }

        await connectTokens();
        await getHolderInfo();

        if (holderAddresses.length) {
          setIsCalculated(true);
          setHolderAddresses(holderAddresses);
        }
      } else {
        alert('Please install MetaMask!');
      }
    } catch (error) {
      // Removed console.error
      alert('Wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const syncGT = async () => {
    if (!walletAddress) {
      alert('Please connect metamask');
      return;
    }

    try {
      await connectTokens();
      const mintHolderList = [];
      const burnHolderList = [];
      const mintAmountList = [];
      const burnAmountList = [];

      for (let i = 0; i < holderAddresses.length; i++) {
        const holder = holderAddresses[i];
        if (holder.holder !== '' && !holder.isExistEmail) {
          const expectedGTbyCredit = isNaN(holder.expectedGTbyCredit) ? 0 : holder.expectedGTbyCredit;
          const totalExpectedGT = expectedGTbyCredit + holder.expectedGTbyLP;

          if (holder.GTBalance < totalExpectedGT) {
            const amount = ethers.utils.parseEther((totalExpectedGT - holder.GTBalance).toString());
            mintHolderList.push(holder.holder);
            mintAmountList.push(amount);
          } else if (holder.GTBalance > totalExpectedGT) {
            const amount = ethers.utils.parseEther((holder.GTBalance - totalExpectedGT).toString());
            burnHolderList.push(holder.holder);
            burnAmountList.push(amount);
          }
        }
      }

      if (mintHolderList.length > 0 || burnHolderList.length > 0) {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const gasPrice = await provider.getGasPrice();
        const increasedGasPrice = gasPrice.mul(110).div(100);

        const txOptions = {
          gasLimit: 5000000,
          gasPrice: increasedGasPrice,
        };

        if (mintHolderList.length > 0 && burnHolderList.length > 0) {
          const tx = await SyncModule.sync(mintHolderList, mintAmountList, burnHolderList, burnAmountList, txOptions);
          await tx.wait();
        } else if (mintHolderList.length > 0) {
          const tx = await SyncModule.mintList(mintHolderList, mintAmountList, txOptions);
          await tx.wait();
        } else {
          const tx = await SyncModule.burnList(burnHolderList, burnAmountList, txOptions);
          await tx.wait();
        }
        setSuccess(true);
      } else {
        setError('No holders need syncing. All holders are already in sync with their expected GT balances.');
      }
    } catch (error) {
      setError('Error synchronizing GT tokens: ' + error.message);
    }
  };

  const resetSyncList = () => {
    setHolderAddresses([]);
    setIsCalculated(false);
    setSuccess(false);
    setError(null);
  };

  return (
    <TabWrapper daoOrganizerAddress={daoOrganizerAddress} chainId={chainId}>
      <Box sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{ mb: 3, pb: 2, color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}
        >
          Sync GT - LP Information
        </Typography>
        <Card sx={{ mb: 3, p: 3, background: 'rgba(255, 255, 255, 0.03)' }}>
          {error && (
            <Typography variant="body2" color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          {success && (
            <Typography variant="body2" sx={{ color: '#00EDC3', mb: 2 }}>
              Successfully synchronized tokens
            </Typography>
          )}

          <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle2" sx={{ color: '#a0a0a0', mb: 1 }}>
                    GT Token Holders
                  </Typography>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleFileUpload(e, 'GT')}
                    style={{
                      color: '#e7e3e3',
                      background: '#282f38',
                      borderRadius: 4,
                      padding: 8,
                      border: '1px solid #00EDC3',
                      width: '100%',
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="subtitle2" sx={{ color: '#a0a0a0', mb: 1 }}>
                    LP Token Holders
                  </Typography>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => handleFileUpload(e, 'LP')}
                    style={{
                      color: '#e7e3e3',
                      background: '#282f38',
                      borderRadius: 4,
                      padding: 8,
                      border: '1px solid #00EDC3',
                      width: '100%',
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={calculateSync} disabled={isLoading} sx={buttonStyles}>
              {isLoading ? (
                <>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Calculating...
                </>
              ) : (
                'Calculate Sync'
              )}
            </Button>
            <Button
              style={{ marginLeft: '10px' }}
              variant="contained"
              onClick={resetSyncList}
              type="button"
              sx={buttonStyles}
            >
              Reset Sync List
            </Button>
            {isCalculated && (
              <Button variant="contained" onClick={syncGT} disabled={isLoading} sx={buttonStyles}>
                {isLoading ? (
                  <>
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                    Syncing...
                  </>
                ) : (
                  'Sync GT'
                )}
              </Button>
            )}
          </Box>
        </Card>

        {holderAddresses.length > 0 && (
          <Card sx={{ p: 3, background: 'rgba(255, 255, 255, 0.03)' }}>
            <Typography
              variant="h6"
              sx={{ mb: 3, pb: 2, color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}
            >
              Holder Information
            </Typography>
            <Box
              sx={{
                overflowX: 'auto',
                overflowY: 'auto',
                width: '100%',
                maxHeight: '500px',
              }}
            >
              <Table sx={{ minWidth: 1500 }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      ID
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      LP Holder Address
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      LP Holding Amount
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      LP Percentage
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      GT Balance
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      GT by LP
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      GT by Credit
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      Email
                    </TableCell>
                    <TableCell sx={{ color: '#a0a0a0', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                      Total Credit
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading && (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={9} sx={{ textAlign: 'center', color: '#fff' }}>
                        Loading...
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                {!isLoading && holderAddresses.length > 0 && (
                  <TableBody>
                    {holderAddresses.map((holder, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.holder}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.LPBalance ? holder.LPBalance.toFixed(8) : '0.00000000'}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.percentage.toFixed(4)}%
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.GTBalance ? holder.GTBalance.toFixed(8) : '0.00000000'}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.expectedGTbyLP ? holder.expectedGTbyLP.toFixed(8) : '0.00000000'}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.expectedGTbyCredit ? holder.expectedGTbyCredit.toFixed(8) : '0.00000000'}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: holder.isExistEmail || holder.holder === '' ? 'red' : '#fff',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                          }}
                        >
                          {holder.email || ''}
                        </TableCell>
                        <TableCell sx={{ color: '#fff', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
                          {holder.totalCredit ? holder.totalCredit.toFixed(8) : '0.00000000'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </Box>
          </Card>
        )}
      </Box>
    </TabWrapper>
  );
};

const mapStateToProps = (state) => ({
  currentDao: state.dao?.currentDao || null,
});

const mapDispatchToProps = {
  getUserCredits,
  getCreditHistoryByNote,
  getAllUserHasKatAddress,
  getEmailsByWalletAddressesInLPSale,
};

export default connect(mapStateToProps, mapDispatchToProps)(SyncGTLPTab);
